import * as tslib_1 from "tslib";
import { Component } from "vue-property-decorator";
import { DropdownControl } from "../control/dropdown-control";
// import { Select, Tooltip } from "@h3/antd-vue";
import { Select, Tooltip } from "@h3/antd-vue";
let Dropdown = class Dropdown extends DropdownControl {
    onChange(val) {
        this.hasSelectBatchImport = false;
        if (val && val.length > 0) {
            this.setValue(Array.isArray(val) ? val.slice() : val);
        }
        else {
            this.ctrl.value = null;
        }
        this.val = val;
        if (!this.multiple) {
            return;
        }
        super.resetDisableds();
    }
    getOPt() {
        let dateItem;
        if (this.control.parentKey) {
            dateItem = this.getDataItem(this.control.key, this.control.parentKey);
        }
        else {
            dateItem = this.getDataItem(this.control.key);
        }
        // 如果是单选，复选的业务模型 , 3种数据格式，注意，大坑！！！！！！！！！
        if (this.control.type == 7) {
            if (this.control.options) {
                const data = this.control.options.options;
                if (data.indexOf('schemaCode') != -1) {
                    console.log(JSON.parse(data));
                    if (JSON.parse(data).labels && JSON.parse(data).labels.length > 0) {
                        if (Array.isArray(JSON.parse(data).labels)) {
                            const sheetDataItem = JSON.parse(data).sheetDataItem;
                            const labels = JSON.parse(data).labels;
                            const options = labels.map((item) => {
                                return item.data[sheetDataItem];
                            });
                            this.control.options.options = options.join(';');
                        }
                        else {
                            const optionsObj = JSON.parse(data).labels;
                            const sheetDataItem = JSON.parse(optionsObj).sheetDataItem;
                            const labels = JSON.parse(optionsObj).labels;
                            const options = labels.map((item) => {
                                return item.data[sheetDataItem];
                            });
                            this.control.options.options = options.join(';');
                        }
                    }
                    else {
                        super.getOptions();
                    }
                }
                else {
                    try {
                        if (JSON.parse(JSON.parse(data).options).labels && JSON.parse(JSON.parse(data).options).labels.length > 0) {
                            const sheetDataItem = JSON.parse(JSON.parse(data).options).sheetDataItem;
                            const labels = JSON.parse(JSON.parse(data).options).labels;
                            const options = labels.map(item => {
                                return item.data[sheetDataItem];
                            });
                            this.control.options.options = options.join(';');
                        }
                        else {
                            super.getOptions();
                        }
                    }
                    catch (error) {
                        if (dateItem) {
                            const optionsJson = dateItem.options ? JSON.parse(dateItem.options) : '';
                            if (optionsJson) {
                                //let dropDownOptionsJson = optionsJson.options ? JSON.parse(optionsJson.options) : '';
                                let dropDownOptionsJson = (optionsJson.options && /^(\{).*(\})$/.test(optionsJson.options)) ? JSON.parse(optionsJson.options) : '';
                                if (dropDownOptionsJson && dropDownOptionsJson.schemaCode && dropDownOptionsJson.condition) {
                                    // 业务模型配置方式并且配置查询条件，则需要重新请求后台加载数据
                                    super.getOptions();
                                }
                                else {
                                    this.options = data.split(";");
                                }
                            }
                            else {
                                this.options = data.split(";");
                            }
                        }
                        else {
                            this.options = data.split(";");
                        }
                    }
                }
            }
        }
        else {
            super.getOptions();
        }
    }
    clearOption(change) {
        this.options = [];
        this.ctrl.value = null;
    }
    destroyed() {
        super.destroyed();
    }
};
Dropdown = tslib_1.__decorate([
    Component({
        name: "dropdown",
        components: {
            ATooltip: Tooltip,
            ASelect: Select,
            ASelectOption: Select.Option,
        },
    })
], Dropdown);
export default Dropdown;
